import { ArrowIcon } from '@icons'
import cn from 'classnames'
import './LargeButton.scss'

interface Props {
  className?: string
  spacing?: boolean
  onClick?: () => void
  [key: string]: any
}

function LargeButton({ className, spacing, onClick, children, ...rest }: Props) {
  return (
    <div onClick={onClick} className={cn('large-button', className, { spacing })} {...rest}>
      {children}
      <span className='side-bar'>
        <span className='icon'>
          <ArrowIcon />
        </span>
      </span>
    </div>
  )
}

export default LargeButton
